module.exports = {
  'AccountNumber': {
    location: 'Consumer.Account'
  },
  'Amount': {
    location: 'OrderDetails'
  },
  'BillingAddress1': {
    location: 'Consumer.BillingAddress',
    fieldName: 'Address1'
  },
  'BillingAddress2': {
    location: 'Consumer.BillingAddress',
    fieldName: 'Address2'
  },
  'BillingAddress3': {
    location: 'Consumer.BillingAddress',
    fieldName: 'Address3'
  },
  'BillingCity': {
    location: 'Consumer.BillingAddress',
    fieldName: 'City'
  },
  'BillingCountryCode': {
    location: 'Consumer.BillingAddress',
    fieldName: 'CountryCode'
  },
  'BillingFirstName': {
    location: 'Consumer.BillingAddress',
    fieldName: 'FirstName'
  },
  'BillingLastName': {
    location: 'Consumer.BillingAddress',
    fieldName: 'LastName'
  },
  'BillingPhone1': {
    location: 'Consumer.BillingAddress',
    fieldName: 'Phone1'
  },
  'BillingPostalCode': {
    location: 'Consumer.BillingAddress',
    fieldName: 'PostalCode'
  },
  'BillingState': {
    location: 'Consumer.BillingAddress',
    fieldName: 'State'
  },
  'CurrencyCode': {
    location: 'OrderDetails'
  },
  'Email1': {
    location: 'Consumer'
  },
  'ExpirationMonth': {
    location: 'Consumer.Account'
  },
  'ExpirationYear': {
    location: 'Consumer.Account'
  },
  'NameOnAccount': {
    location: 'Consumer.Account'
  },
  'OrderChannel': {
    location: 'OrderDetails'
  },
  'OrderDescription': {
    location: 'OrderDetails'
  },
  'OrderNumber': {
    location: 'OrderDetails'
  },
  'ShippingAddress1': {
    location: 'Consumer.ShippingAddress',
    fieldName: 'Address1'
  },
  'ShippingAddress2': {
    location: 'Consumer.ShippingAddress',
    fieldName: 'Address2'
  },
  'ShippingAddress3': {
    location: 'Consumer.ShippingAddress',
    fieldName: 'Address3'
  },
  'ShippingCity': {
    location: 'Consumer.ShippingAddress',
    fieldName: 'City'
  },
  'ShippingCountryCode': {
    location: 'Consumer.ShippingAddress',
    fieldName: 'CountryCode'
  },
  'ShippingFirstName': {
    location: 'Consumer.ShippingAddress',
    fieldName: 'FirstName'
  },
  'ShippingLastName': {
    location: 'Consumer.ShippingAddress',
    fieldName: 'LastName'
  },
  'ShippingPhone1': {
    location: 'Consumer.ShippingAddress',
    fieldName: 'Phone1'
  },
  'ShippingPostalCode': {
    location: 'Consumer.ShippingAddress',
    fieldName: 'PostalCode'
  },
  'ShippingState': {
    location: 'Consumer.ShippingAddress',
    fieldName: 'State'
  },
  'TransactionId': {
    location: 'OrderDetails'
  }
}


//////////////////
// WEBPACK FOOTER
// ./config/annotatedFieldsWhiteList.js
// module id = 30
// module chunks = 0 5 20